import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { LegalEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

export type OptionalValidationError = ValidationErrors | null;

const MAX_SUBSCRIPTION_UNITS_FIELD_NAME = 'Max. Subscription Units';
const MIN_SUBSCRIPTION_UNITS_FIELD_NAME = 'Min. Subscription Units';
const MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME = 'Max. Subscription Amount';
const MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME = 'Min. Subscription Amount';

// firstControl should be less than secondControl
// both firstControl and seconControl should be multiples of thirdControl
export function greaterLessRemainderComboValidator3(
  firstControl: string,
  secondControl: string,
  thirdControl?: string
): ValidatorFn {
  return (control: FormGroup): OptionalValidationError => {
    const fieldType = thirdControl ? 'Amount' : 'Units';

    if (fieldType === 'Units') {
      return validateUnits(control);
    } else if (fieldType === 'Amount') {
      return validateAmount(control);
    }
  };

  function getControls(form: FormGroup) {
    const controlOneField = form.get(firstControl);
    const controlTwoField = form.get(secondControl);
    const controlThreeField = form.get(thirdControl);

    const controlOne = controlOneField.value;
    const controlTwo = controlTwoField.value;
    const controlThree = controlThreeField?.value;

    return {
      controlOneField,
      controlTwoField,
      controlThreeField,
      controlOne,
      controlTwo,
      controlThree,
    };
  }

  function validateUnits(control: FormGroup): OptionalValidationError {
    const {
      controlOneField: minTradingAmount,
      controlTwoField: maxTradingAmount,
      controlTwo: maxTradingAmountValue,
      controlOne: minTradingAmountValue,
    } = getControls(control);

    const units = control.get(LegalEnum.numberOfUnits).value;
    const unitsAsString =
      typeof units === 'number' ? (units ? units.toString() : '') : units;

    minTradingAmount.setErrors(null);
    maxTradingAmount.setErrors(null);

    if (
      !isNullUndefinedOrEmpty(minTradingAmountValue) &&
      !isNullUndefinedOrEmpty(maxTradingAmountValue)
    ) {
      if (Number(minTradingAmountValue) >= Number(maxTradingAmountValue)) {
        minTradingAmount.setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_UNITS_FIELD_NAME} should be less than ${MAX_SUBSCRIPTION_UNITS_FIELD_NAME}`,
        });
        maxTradingAmount.setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_UNITS_FIELD_NAME} should be greater than ${MIN_SUBSCRIPTION_UNITS_FIELD_NAME}`,
        });

        maxTradingAmount.markAsTouched();
        minTradingAmount.markAsTouched();
        return { incorrect: true };
      }
    } else {
      return null;
    }

    if (!unitsAsString?.trim().length) {
      return null;
    }

    if (secondControl === LegalEnum.maxTradingUnits) {
      if (Number(units) < Number(maxTradingAmountValue)) {
        maxTradingAmount.setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_UNITS_FIELD_NAME} should be less than Number of Units`,
        });
        maxTradingAmount.markAsTouched();
        return { incorrect: true };
      }
    }
  }

  function validateAmount(control: FormGroup): OptionalValidationError {
    const { controlOne, controlTwo, controlThree } = getControls(control);
    if (!!controlOne && !!controlTwo && !!controlThree) {
      if (
        Number(controlOne) % Number(controlThree) !== 0 &&
        Number(controlTwo) % Number(controlThree) !== 0 &&
        Number(controlOne) >= Number(controlTwo)
      ) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination and should be less than ${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination and should be more than ${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        return { incorrect: true };
      }

      if (
        Number(controlOne) % Number(controlThree) !== 0 &&
        Number(controlTwo) % Number(controlThree) !== 0 &&
        Number(controlOne) < Number(controlTwo)
      ) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination`,
        });
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination`,
        });
        return { incorrect: true };
      }

      if (
        Number(controlOne) % Number(controlThree) !== 0 &&
        Number(controlTwo) % Number(controlThree) === 0 &&
        Number(controlOne) >= Number(controlTwo)
      ) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination and should be less than ${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be more than ${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        return { incorrect: true };
      }

      if (
        Number(controlOne) % Number(controlThree) !== 0 &&
        Number(controlTwo) % Number(controlThree) === 0 &&
        Number(controlOne) < Number(controlTwo)
      ) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination`,
        });
        control.get(secondControl).setErrors(null);
        return { incorrect: true };
      }

      if (
        Number(controlOne) % Number(controlThree) === 0 &&
        Number(controlTwo) % Number(controlThree) !== 0 &&
        Number(controlOne) >= Number(controlTwo)
      ) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be less than ${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination and should be more than ${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        return { incorrect: true };
      }
      if (
        Number(controlOne) % Number(controlThree) === 0 &&
        Number(controlTwo) % Number(controlThree) !== 0 &&
        Number(controlOne) < Number(controlTwo)
      ) {
        control.get(firstControl).setErrors(null);
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination`,
        });
        return { incorrect: true };
      }
      if (
        Number(controlOne) % Number(controlThree) === 0 &&
        Number(controlTwo) % Number(controlThree) === 0 &&
        Number(controlOne) >= Number(controlTwo)
      ) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be less than ${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be more than ${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        return { incorrect: true };
      }
    }

    if (!!controlOne && !!controlTwo && !controlThree) {
      if (Number(controlOne) >= Number(controlTwo)) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be less than ${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be more than ${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME}`,
        });
        return { incorrect: true };
      }
    }

    if (!!controlOne && !controlTwo && !!controlThree) {
      if (Number(controlOne) % Number(controlThree) !== 0) {
        control.get(firstControl).setErrors({
          incorrect: true,
          message: `${MIN_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination`,
        });
        control.get(secondControl).setErrors(null);
        return { incorrect: true };
      }
    }

    if (!controlOne && !!controlTwo && !!controlThree) {
      if (Number(controlTwo) % Number(controlThree) !== 0) {
        control.get(firstControl).setErrors(null);
        control.get(secondControl).setErrors({
          incorrect: true,
          message: `${MAX_SUBSCRIPTION_AMOUNT_FIELD_NAME} should be a multiple of Denomination`,
        });
        return { incorrect: true };
      }
    }

    control.get(firstControl).setErrors(null);
    control.get(secondControl).setErrors(null);
    return null;
  }
}

export function isNullUndefinedOrEmpty(value: any): boolean {
  value = Number.isNaN(value) ? value : value?.toString();
  return !value?.trim().length;
}
